(() => {
  if (customElements.get('copirema-thesis-wizard')) return;

  const PAPERS = {
    '80': { label: '80 grammi', bw: 5, color: 30 },
    '100-OPACO': { label: '100 grammi opaca', bw: 10, color: 40 },
    '100-LUCIDO': { label: '100 grammi lucido', bw: 15, color: 50 },
    '120-OPACO': { label: '120 grammi opaco', bw: 15, color: 50 },
    '120-LUCIDO': { label: '120 grammi lucido', bw: 20, color: 60 },
    '80-RICICLATA': { label: '80 grammi riciclata', bw: 8, color: 35 },
    '100-AVORIO': { label: '100 grammi avorio', bw: 15, color: 50 }
  };

  const COVER_DISCOUNT_GROUPS = [
    {
      key: 'TINTA_UNITA',
      rates: { 2: 1000, 3: 3000, 4: 4000, 5: 5000 },
      products: ['BORDEAUX WINE','MAGENTA','VIOLA LUCIDO','LILLA','PESCA','ROSA CIPRIA','ROSA PALLIDO','ROSA BARBIE','BISCOTTO','AVORIO MARMORIZZATO','AVORIO','CHAMPAGNE','BIANCO GHIACCIO','BLUE NARCOTIQUE','BLU ZAFFIRO','BLUE ROYAL','AZZURRO CARTA DA ZUCCHERO','AZZURRO LUCIDO','VERDE PINO','VERDE MUSCHIO','GIALLO SENAPE','ZUCCA','NERO OPACO','NERO LUCIDO','GRIGIO TOPO','GRIGIO CHIARO','FANGO','GRIGIO ANTRACITE','AMARANTO']
    },
    {
      key: 'SPECIALI',
      rates: { 2: 800, 3: 2400, 4: 3200, 5: 4000 },
      products: ['VINACCIA','ROSSO FUOCO','ROSSO CAMELIA','FUCSIA FLAMENCO','FUCSIA CICLAMINO','VIOLETTA DI PARMA','GLICINE','ROSA ANTICO','ROSA COSMICO','ROSA DIVINO','BIANCO PORCELLANA','BIANCO CRISTALLO',"LUNA D'ORO",'BIANCO COSMICO','POLVERE','BLU MAJORELLE','BLU MEZZANOTTE','BLUE TALISMAN','BLU OLTREMARE','BLU COSMICO','MENTA COSMICO','PETROLIO','VERDE PERSIANO','VERDE FORESTA','VERDE MELA','NERO COSMICO','NERO GRAFITE','CREMA','SABBIA','LOVE GOLD','PERLA']
    },
    {
      key: 'PREMIUM',
      rates: { 2: 800, 3: 2400, 4: 3200, 5: 4000 },
      products: ['ROSSO PELLE','SETA CILIGIA','SETA ROSSA','ROSSO NATURALE','ROSSO VELLUTO','ROSA PEONIA','ROSA MIRABILIS','ROSA FENICOTTERO','ROSA CORALLO','FUCSIA NATURALE','FUCSIA VELLUTO','ORCHIDEA NATURALE','SETA VIOLA','VIOLA ORTENSIA','PELLE VIOLA','IRIS','LILLA VELLUTO','LAVANDA NATURALE','BLU RIO','BLU NAVY','BLU PELLE','BLU NATURALE','INDACO NATURALE','BLU VELLUTO','AZZURRO CINDERELLA','AZZURRO NATURALE','TURCHESE NATURALE','VERDE BOTTIGLIA','TIFFANY','TIFFANY SETA','OTTANIO','VERDE TRIFOGLIO','SALVIA VELLUTO','PISTACCHIO','VERDE BOSCO','VERDE SMERALDO','VERDE VELLUTO','VERDE PELLE','VERDE NATURALE','CIOCCOLATO','CACAO CAVALLINO','CAVALLINO CARAMELLO','NOCE','NOCCIOLA','TOFFIE','BEIGE CAVALLINO','BEIGE NATURALE','NUDE VELLUTO','PLATINO','CAROTA','ACE','GIALLO LIMONE','GRIGIO CAVALLINO','VERDE SALVIA','VERDE OLIVA','FIORDALISO','CERULEO','ROSSO RUBINO','BORGOGNA','AZZURRO MARE']
    },
    {
      key: 'BASICHE',
      rates: { 2: 600, 3: 1800, 4: 2400, 5: 3000 },
      products: ['ROSSO FIOCCO','PORPORA','FUCSIA','HOLLYWOOD','ROSA CONFETTO','AZZURRO BABY','BLU EGIZIANO','BLU FIOCCO','VERDE ERBA','VERDE GIADA','VERDE LIME','ARANCIONE','BIANCO KELLT','BEIGE KELLY','ROSA BABY','ZAFFERANO','ROSSO RIBES','VERDE BASILICO','ROSA BLUSH','VANIGLIA','MANDORLA','BLU OXFORD','ROSSO SANGRIA']
    },
    {
      key: 'SIMILPELLE_CLASSICHE',
      rates: { 2: 1000, 3: 3000, 4: 4000, 5: 5000 },
      products: ['ROSSO MARMORIZZATO','ROSSO LUCIDO','BLU MARMORIZZATO','VERDE MARMORIZZATO','BORDEAUX MARMORIZZATO']
    }
  ].map((group) => ({ ...group, normalized: new Set(group.products.map(normalizeProductName)) }));

  // Stato temporaneo esclusivo del configuratore ORDINE.
  // Il preventivo rapido non usa questa chiave e non condivide la sessione.
  const WIZARD_STORAGE_KEY = 'copirema:ordine-tesi:v2';
  const WIZARD_LEGACY_STORAGE_KEYS = ['copirema-thesis-wizard-saved-v1'];
  const WIZARD_STORAGE_MAX_AGE = 2 * 60 * 60 * 1000;

  class CopiremaQuickQuote extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.coverProducts = this.readCoverProducts();
      this.printVariants = this.readPrintVariants();
      this.coverByHandle = new Map([...this.coverProducts.values()].map((row) => [String(row.handle || ''), row]));
      this.primaryCover = this.readPrimaryCover();
      this.initialCopies = this.readInitialCopies();
      this.extraCover = { cover: null, mode: 'same', copies: 1, file: null, analysis: null, analyzing: false };
      this.paperInput = this.querySelector('[data-paper]');
      this.colorModeInput = this.querySelector('[data-color-mode]');
      this.printModeInput = this.querySelector('[data-print-mode]');
      this.duplexWarning = this.querySelector('[data-duplex-warning]');
      this.duplexConfirm = this.querySelector('[data-duplex-confirm]');
      this.wordInput = this.querySelector('[data-word]');
      this.phoneInput = this.querySelector('[data-phone]');
      this.paperNotice = this.querySelector('[data-paper-notice]');
      this.pdfList = this.querySelector('[data-pdf-list]');
      this.pdfTemplate = this.querySelector('[data-pdf-template]');
      this.errorBox = this.querySelector('[data-error]');
      this.progress = this.querySelector('[data-progress]');
      this.entries = new Map();
      this.analysisQueue = Promise.resolve();
      this.currentStep = 1;
      this.lastFreeShippingState = false;
      this.persistedJobId = '';
      this.savedWordUrl = '';
      this.savedWordName = '';

      this.populateExtraCoverOptions();
      this.renderPrimaryCover();
      this.bindExtraCoverControls();
      this.querySelector('[data-add-pdf]')?.addEventListener('click', () => this.addPdfRow());
      this.paperInput?.addEventListener('change', () => { this.applyPaperRules(); this.render(); });
      this.printModeInput?.addEventListener('change', () => { this.updateDuplexWarning(); this.applyPaperRules(); this.render(); });
      this.colorModeInput?.addEventListener('change', () => { this.updateColorHelp(); this.render(); });
      this.duplexConfirm?.addEventListener('change', () => this.clearError());
      this.querySelector('[data-prev]')?.addEventListener('click', () => {
        if (this.currentStep > 1) {
          this.goToStep(this.currentStep - 1);
          return;
        }
        this.returnToCoverProduct();
      });
      this.querySelector('[data-next]')?.addEventListener('click', () => this.nextStep());
      this.querySelector('[data-submit-order]')?.addEventListener('click', () => this.submitOrder());
      this.querySelectorAll('[data-step-jump]').forEach((button) => button.addEventListener('click', () => {
        const target = Number(button.dataset.stepJump || 1);
        if (target < this.currentStep) this.goToStep(target);
      }));

      this.cleanupTemporaryStorage();
      const restored = this.restorePersistedState();
      if (!restored) this.addPdfRow(this.initialCopies);
      this.updateColorHelp();
      this.updateDuplexWarning();
      this.updateWizard();
    }

    readCoverProducts() {
      try {
        const rows = JSON.parse(this.querySelector('[data-cover-products]')?.textContent || '[]');
        return new Map(rows.map((row) => [String(row.id), { ...row, price: Number(row.price || 0) }]));
      } catch (error) {
        console.error('Configurazione copertine preventivo non valida', error);
        return new Map();
      }
    }

    readPrintVariants() {
      try {
        const rows = JSON.parse(this.querySelector('[data-print-variants]')?.textContent || '[]');
        return new Map(rows.filter((row) => row?.sku).map((row) => [String(row.sku), { id: Number(row.id), available: row.available !== false }]));
      } catch (error) {
        console.error('Configurazione prodotto tecnico stampa non valida', error);
        return new Map();
      }
    }

    readPrimaryCover() {
      const params = new URLSearchParams(window.location.search);
      const handle = params.get('cover') || '';
      const fromCollection = this.coverByHandle.get(handle);
      if (fromCollection) {
        const variantId = params.get('cover_variant') || '';
        const passedPrice = Number(params.get('cover_price'));
        return {
          ...fromCollection,
          variantId: variantId || fromCollection.variantId || '',
          price: Number.isFinite(passedPrice) && passedPrice > 0 ? passedPrice : fromCollection.price
        };
      }

      const title = params.get('cover_title') || '';
      const id = params.get('cover_id') || '';
      const price = Number(params.get('cover_price'));
      if (!handle && !title && !id) return null;
      return {
        id: id || handle || title,
        handle,
        title: title || handle.replace(/-/g, ' '),
        url: params.get('cover_url') || (handle ? `/products/${encodeURIComponent(handle)}` : ''),
        image: params.get('cover_image') || null,
        price: Number.isFinite(price) ? price : 0,
        variantId: params.get('cover_variant') || '',
        available: true,
        fromUrl: true
      };
    }


    readInitialCopies() {
      const params = new URLSearchParams(window.location.search);
      return Math.max(1, Math.min(99, parseInt(params.get('cover_copies') || '1', 10) || 1));
    }

    storageIdentity() {
      const cover = this.primaryCover || {};
      return String(cover.variantId || cover.id || cover.handle || '');
    }

    cleanupTemporaryStorage() {
      try {
        const storage = window.sessionStorage;
        if (!storage) return;

        // Elimina le vecchie chiavi usate dalle versioni precedenti del configuratore.
        WIZARD_LEGACY_STORAGE_KEYS.forEach((key) => storage.removeItem(key));

        const raw = storage.getItem(WIZARD_STORAGE_KEY);
        if (!raw) return;
        const saved = JSON.parse(raw);
        const savedAt = Number(saved?.savedAt || 0);
        if (!savedAt || Date.now() - savedAt > WIZARD_STORAGE_MAX_AGE) {
          storage.removeItem(WIZARD_STORAGE_KEY);
        }
      } catch (_) {
        try { window.sessionStorage?.removeItem(WIZARD_STORAGE_KEY); } catch (_) {}
      }
    }

    restorePersistedState() {
      let saved;
      try { saved = JSON.parse(window.sessionStorage?.getItem(WIZARD_STORAGE_KEY) || 'null'); }
      catch (_) { return false; }
      if (!saved || !saved.savedAt || Date.now() - Number(saved.savedAt) > WIZARD_STORAGE_MAX_AGE) {
        try { window.sessionStorage?.removeItem(WIZARD_STORAGE_KEY); } catch (_) {}
        return false;
      }
      if (String(saved.coverIdentity || '') !== this.storageIdentity()) return false;
      if (!Array.isArray(saved.pdfs) || !saved.pdfs.length) return false;

      this.persistedJobId = String(saved.jobId || '');
      this.savedWordUrl = String(saved.wordUrl || '');
      this.savedWordName = String(saved.wordName || '');
      if (this.printModeInput && saved.printMode) this.printModeInput.value = saved.printMode;
      if (this.colorModeInput && saved.colorMode) this.colorModeInput.value = saved.colorMode;
      if (this.paperInput && saved.paper) this.paperInput.value = saved.paper;
      if (this.duplexConfirm) this.duplexConfirm.checked = Boolean(saved.duplexConfirmed);
      if (this.phoneInput) this.phoneInput.value = saved.phone || '';

      for (const pdf of saved.pdfs) this.addPdfRow(pdf.copies || 1, pdf);

      if (saved.extraCover?.id) {
        const extra = this.coverProducts.get(String(saved.extraCover.id));
        if (extra) {
          this.extraCover.cover = extra;
          this.extraCover.mode = saved.extraCover.mode || 'same';
          this.extraCover.copies = Math.max(1, Number(saved.extraCover.copies || 1));
          this.extraCover.analysis = saved.extraCover.analysis || null;
          this.extraCover.savedUrl = saved.extraCover.url || '';
          this.extraCover.savedName = saved.extraCover.name || '';
          const coverInput = this.querySelector('[data-extra-cover]');
          const copiesInput = this.querySelector('[data-extra-cover-copies]');
          if (coverInput) coverInput.value = String(extra.id);
          if (copiesInput) copiesInput.value = String(this.extraCover.copies);
          const mode = this.querySelector(`[data-extra-files][value="${this.extraCover.mode}"]`);
          if (mode) mode.checked = true;
          const box = this.querySelector('[data-extra-new-files]');
          if (box) box.hidden = this.extraCover.mode !== 'new';
          if (this.extraCover.mode === 'new') {
            const status = this.querySelector('[data-extra-pdf-status]');
            if (status) status.textContent = `${this.extraCover.savedName || 'PDF già caricato'} · già nel carrello`;
            const front = this.querySelector('[data-extra-frontespizio]');
            if (front) front.hidden = false;
            const radio = this.querySelector(`[data-extra-front-choice][value="${saved.extraCover.frontChoice || ''}"]`);
            if (radio) radio.checked = true;
          }
        }
      }

      this.currentStep = Math.max(1, Math.min(5, Number(saved.step || 5)));
      return true;
    }

    savePersistedState(jobId) {
      const pdfs = [...this.entries].map(([row, entry]) => ({
        name: entry.file?.name || entry.savedName || '',
        url: entry.savedUrl || '',
        analysis: entry.analysis || null,
        copies: this.getRowCopies(row),
        frontChoice: this.frontespizioChoice(row)
      }));
      const extraFront = [...this.querySelectorAll('[data-extra-front-choice]')].find((radio) => radio.checked)?.value || '';
      const state = {
        savedAt: Date.now(),
        jobId: jobId || this.persistedJobId || '',
        coverIdentity: this.storageIdentity(),
        printMode: this.printModeInput?.value || '',
        colorMode: this.colorModeInput?.value || '',
        paper: this.paperInput?.value || '',
        duplexConfirmed: Boolean(this.duplexConfirm?.checked),
        phone: String(this.phoneInput?.value || ''),
        wordUrl: this.savedWordUrl || '',
        wordName: this.wordInput?.files?.[0]?.name || this.savedWordName || '',
        pdfs,
        extraCover: this.extraCover.cover ? {
          id: String(this.extraCover.cover.id), mode: this.extraCover.mode, copies: this.extraCover.copies,
          analysis: this.extraCover.analysis || null,
          name: this.extraCover.file?.name || this.extraCover.savedName || '',
          url: this.extraCover.savedUrl || '', frontChoice: extraFront
        } : null,
        step: 5
      };
      try { window.sessionStorage?.setItem(WIZARD_STORAGE_KEY, JSON.stringify(state)); } catch (_) {}
    }

    captureUploadedProperties(result) {
      const props = result?.properties || {};
      const pdfValues = Object.entries(props)
        .filter(([key, value]) => /^PDF tesi(?: \d+)?$/i.test(key) && value)
        .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }))
        .map(([, value]) => String(value));
      let i = 0;
      for (const [, entry] of this.entries) {
        if (pdfValues[i]) entry.savedUrl = pdfValues[i];
        if (entry.file?.name) entry.savedName = entry.file.name;
        i += 1;
      }
      if (props['Frontespizio Word']) this.savedWordUrl = String(props['Frontespizio Word']);
      if (this.wordInput?.files?.[0]?.name) this.savedWordName = this.wordInput.files[0].name;
    }

    populateExtraCoverOptions() {
      const input = this.querySelector('[data-extra-cover]');
      if (!input) return;
      const rows = [...this.coverProducts.values()].sort((a, b) => String(a.title).localeCompare(String(b.title), 'it'));
      rows.forEach((cover) => {
        const option = document.createElement('option');
        option.value = String(cover.id);
        option.textContent = `${cover.title} — ${formatMoney(cover.price)}${cover.available ? '' : ' — non disponibile'}`;
        option.disabled = !cover.available;
        input.appendChild(option);
      });
    }

    selectedCover() { return this.primaryCover; }

    renderPrimaryCover() {
      const preview = this.querySelector('[data-primary-cover-preview]');
      const missing = this.querySelector('[data-no-primary-cover]');
      const cover = this.primaryCover;
      if (missing) missing.hidden = Boolean(cover);
      if (!preview) return;
      preview.hidden = !cover;
      if (!cover) return;
      this.querySelector('[data-primary-cover-title]').textContent = cover.title;
      const wrap = this.querySelector('[data-primary-cover-image-wrap]');
      const image = this.querySelector('[data-primary-cover-image]');
      if (cover.image && wrap && image) { image.src = cover.image; image.alt = cover.title; wrap.hidden = false; }
      else if (wrap) wrap.hidden = true;
      this.updatePrimaryCoverPricing();
    }

    primaryCopies() {
      const copies = [...this.entries?.keys?.() || []].reduce((sum, row) => sum + this.getRowCopies(row), 0);
      return Math.max(1, copies || 1);
    }

    primaryCoverPricing() {
      const cover = this.primaryCover;
      const copies = this.primaryCopies();
      if (!cover) return { copies, gross: 0, discount: 0, net: 0 };
      const gross = Number(cover.price || 0) * copies;
      const group = discountGroupFor(cover.title);
      const discount = group ? discountForQuantity(group.rates, copies) : 0;
      return { copies, gross, discount, net: Math.max(0, gross - discount) };
    }

    updatePrimaryCoverPricing() {
      const pricing = this.primaryCoverPricing();
      const price = this.querySelector('[data-primary-cover-price]');
      const gross = this.querySelector('[data-primary-cover-gross]');
      const note = this.querySelector('[data-primary-cover-discount-note]');
      const discount = this.querySelector('[data-primary-cover-discount]');
      if (price) price.textContent = this.primaryCover ? `${pricing.copies} ${pricing.copies === 1 ? 'copia' : 'copie'} · ${formatMoney(pricing.net)}` : '—';
      if (gross) { gross.hidden = !this.primaryCover || pricing.discount <= 0; gross.textContent = formatMoney(pricing.gross); }
      if (note && discount) { note.hidden = !this.primaryCover || pricing.discount <= 0; discount.textContent = `−${formatMoney(pricing.discount)}`; }
    }

    calculatePrimaryTotals() {
      const totals = { copies: 0, bwUnits: 0, colorUnits: 0 };
      const allBw = this.colorModeInput?.value === 'all-bw';
      for (const [row, entry] of this.entries) {
        const copies = this.getRowCopies(row);
        totals.copies += copies;
        if (!entry.analysis) continue;
        const printed = entry.analysis.total * copies;
        if (allBw) totals.bwUnits += printed;
        else {
          totals.bwUnits += entry.analysis.bw * copies;
          totals.colorUnits += (entry.analysis.color + entry.analysis.gray) * copies;
        }
      }
      return totals;
    }

    updateStepOneCosts() {
      const pricing = this.primaryCoverPricing();
      const coverTotal = this.querySelector('[data-step-cover-total]');
      const coverGross = this.querySelector('[data-step-cover-gross]');
      const printTotal = this.querySelector('[data-step-print-total]');
      const partial = this.querySelector('[data-step-partial-total]');
      if (coverTotal) coverTotal.textContent = this.primaryCover ? formatMoney(pricing.net) : '—';
      if (coverGross) { coverGross.hidden = !this.primaryCover || pricing.discount <= 0; coverGross.textContent = formatMoney(pricing.gross); }
      if (!this.allFilesReady()) {
        if (printTotal) printTotal.textContent = 'In attesa del PDF';
        if (partial) partial.textContent = '—';
        return;
      }
      const paper = PAPERS[this.paperInput?.value];
      if (!paper) return;
      const totals = this.calculatePrimaryTotals();
      const printCents = totals.bwUnits * paper.bw + totals.colorUnits * paper.color;
      if (printTotal) printTotal.textContent = formatMoney(printCents);
      if (partial) partial.textContent = this.primaryCover ? formatMoney(pricing.net + printCents) : formatMoney(printCents);
    }

    bindExtraCoverControls() {
      const add = this.querySelector('[data-add-cover]');
      const panel = this.querySelector('[data-extra-cover-panel]');
      const coverInput = this.querySelector('[data-extra-cover]');
      const copiesInput = this.querySelector('[data-extra-cover-copies]');
      const fileInput = this.querySelector('[data-extra-pdf]');
      add?.addEventListener('click', () => { panel.hidden = !panel.hidden; });
      coverInput?.addEventListener('change', () => { this.extraCover.cover = this.coverProducts.get(String(coverInput.value || '')) || null; this.render(); });
      copiesInput?.addEventListener('input', () => { copiesInput.value = String(Math.max(1, Math.min(99, parseInt(copiesInput.value || '1', 10) || 1))); this.extraCover.copies = Number(copiesInput.value); this.render(); });
      this.querySelectorAll('[data-extra-files]').forEach((radio) => radio.addEventListener('change', () => {
        if (!radio.checked) return;
        this.extraCover.mode = radio.value;
        const box = this.querySelector('[data-extra-new-files]');
        if (box) box.hidden = radio.value !== 'new';
        this.render();
      }));
      fileInput?.addEventListener('change', () => {
        const file = fileInput.files?.[0] || null;
        this.extraCover.file = file; this.extraCover.savedUrl = ''; this.extraCover.savedName = file?.name || ''; this.extraCover.analysis = null;
        if (file) this.analyzeExtraFile(file);
      });
      this.querySelectorAll('[data-extra-front-choice]').forEach((radio) => radio.addEventListener('change', () => this.clearError()));
    }

    async analyzeExtraFile(file) {
      const status = this.querySelector('[data-extra-pdf-status]');
      if (!file || (!/\.pdf$/i.test(file.name) && file.type !== 'application/pdf')) { if (status) status.textContent = 'File non valido'; return; }
      this.extraCover.analyzing = true;
      if (status) status.textContent = 'Analisi in corso…';
      try {
        const pdfjs = this.getPdfEngine();
        const pdf = await pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()) }).promise;
        const canvas = this.querySelector('[data-extra-preview]');
        const front = this.querySelector('[data-extra-frontespizio]');
        if (canvas) {
          const page = await pdf.getPage(1); const base = page.getViewport({ scale: 1 }); const scale = Math.min(1.2, 480 / Math.max(1, base.width)); const viewport = page.getViewport({ scale: Math.max(.72, scale) });
          canvas.width = Math.ceil(viewport.width); canvas.height = Math.ceil(viewport.height); const ctx = canvas.getContext('2d', { alpha: false }); ctx.fillStyle='#fff'; ctx.fillRect(0,0,canvas.width,canvas.height); await page.render({canvasContext:ctx,viewport}).promise; page.cleanup();
        }
        const groups={bw:[],gray:[],color:[]};
        for (let number=1; number<=pdf.numPages; number+=1) {
          const page=await pdf.getPage(number); const inspection=classifyOperators(pdfjs, await page.getOperatorList()); let pageClass=inspection.kind;
          if (inspection.needsRaster && pageClass !== 'color') { const base=page.getViewport({scale:1}); const scale=Math.min(2.1,1400/Math.max(base.width,base.height)); const viewport=page.getViewport({scale:Math.max(1.35,scale)}); const c=document.createElement('canvas'); c.width=Math.ceil(viewport.width); c.height=Math.ceil(viewport.height); const ctx=c.getContext('2d',{alpha:false,willReadFrequently:true}); ctx.fillStyle='#fff';ctx.fillRect(0,0,c.width,c.height); await page.render({canvasContext:ctx,viewport}).promise; pageClass=strongestClass(pageClass,classifyPixels(ctx.getImageData(0,0,c.width,c.height).data,c.width,c.height)); }
          groups[pageClass].push(number); page.cleanup(); await new Promise(requestAnimationFrame);
        }
        this.extraCover.analysis={total:pdf.numPages,bw:groups.bw.length,gray:groups.gray.length,color:groups.color.length}; await pdf.destroy();
        if (status) status.textContent=`${this.extraCover.analysis.total} pagine · ${this.extraCover.analysis.bw} BN · ${this.extraCover.analysis.color + this.extraCover.analysis.gray} colore/grigi`;
        if (front) front.hidden=false;
      } catch(error) { console.error(error); this.extraCover.analysis=null; if(status) status.textContent='Analisi non riuscita'; }
      finally { this.extraCover.analyzing=false; this.applyPaperRules(); this.render(); }
    }

    addPdfRow(initialCopies = 1, restored = null) {
      const fragment = this.pdfTemplate.content.cloneNode(true);
      const row = fragment.querySelector('[data-pdf-row]');
      const input = row.querySelector('[data-pdf-input]');
      const copies = row.querySelector('[data-pdf-copies]');
      if (copies) copies.value = String(Math.max(1, Math.min(99, parseInt(initialCopies || '1', 10) || 1)));
      const dropzone = row.querySelector('[data-dropzone]');
      this.entries.set(row, { file: null, analysis: restored?.analysis || null, analyzing: false, savedUrl: restored?.url || '', savedName: restored?.name || '' });
      this.pdfList.appendChild(fragment);
      if (restored) {
        row.querySelector('[data-drop-label]').textContent = restored.name || 'PDF già caricato';
        row.querySelector('[data-pdf-status]').textContent = restored.analysis ? `${restored.analysis.total} pagine · ${restored.analysis.bw} BN · ${restored.analysis.color + restored.analysis.gray} colore/grigi · già nel carrello` : 'PDF già nel carrello';
        const frontCheck = row.querySelector('[data-frontespizio-check]');
        if (frontCheck) frontCheck.hidden = false;
        const choice = row.querySelector(`[data-frontespizio-choice][value="${restored.frontChoice || ''}"]`);
        if (choice) choice.checked = true;
      }

      input.addEventListener('change', () => {
        const file = input.files?.[0];
        if (!file) return;
        const entry = this.entries.get(row);
        entry.file = file;
        entry.savedUrl = '';
        entry.savedName = file.name;
        entry.analysis = null;
        row.querySelector('[data-drop-label]').textContent = file.name;
        row.querySelector('[data-pdf-status]').textContent = 'In coda per l’analisi…';
        this.analysisQueue = this.analysisQueue.then(() => this.analyzeRow(row)).catch((error) => console.error(error));
      });
      row.querySelectorAll('[data-frontespizio-choice]').forEach((choice) => {
        choice.addEventListener('change', () => {
          if (choice.checked) row.querySelectorAll('[data-frontespizio-choice]').forEach((other) => { if (other !== choice) other.checked = false; });
          const error = row.querySelector('[data-frontespizio-error]');
          if (error) error.hidden = true;
          row.querySelector('[data-frontespizio-check]')?.classList.remove('is-invalid');
          this.clearError();
        });
      });

      copies.addEventListener('input', () => {
        copies.value = String(Math.max(1, Math.min(99, parseInt(copies.value || '1', 10) || 1)));
        this.renumberRows();
        this.render();
      });
      row.querySelector('[data-remove-pdf]').addEventListener('click', () => this.removePdfRow(row));
      dropzone.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); input.click(); }
      });
      ['dragenter', 'dragover'].forEach((name) => dropzone.addEventListener(name, () => dropzone.classList.add('is-over')));
      ['dragleave', 'drop'].forEach((name) => dropzone.addEventListener(name, () => dropzone.classList.remove('is-over')));
      this.renumberRows();
      this.render();
    }

    removePdfRow(row) {
      const entry = this.entries.get(row);
      if (entry?.analyzing) return this.showError('Attendi la fine dell’analisi prima di rimuovere questo PDF.');
      if (this.entries.size <= 1) {
        const input = row.querySelector('[data-pdf-input]');
        if (input) input.value = '';
        entry.file = null;
        entry.savedUrl = '';
        entry.savedName = '';
        entry.analysis = null;
        row.querySelectorAll('[data-frontespizio-choice]').forEach((choice) => { choice.checked = false; });
        const frontCheck = row.querySelector('[data-frontespizio-check]');
        if (frontCheck) { frontCheck.hidden = true; frontCheck.classList.remove('is-invalid'); }
        const frontError = row.querySelector('[data-frontespizio-error]');
        if (frontError) frontError.hidden = true;
        row.querySelector('[data-drop-label]').textContent = 'Trascina qui il PDF oppure scegli il file';
        row.querySelector('[data-pdf-status]').textContent = 'In attesa del file';
      } else {
        this.entries.delete(row);
        row.remove();
      }
      this.clearError();
      this.renumberRows();
      this.applyPaperRules();
      this.render();
    }

    renumberRows() {
      [...this.entries.keys()].forEach((row, index) => {
        row.querySelector('[data-pdf-title]').textContent = `PDF ${index + 1}`;
      });
    }

    async analyzeRow(row) {
      const entry = this.entries.get(row);
      if (!entry?.file || !row.isConnected) return;
      this.clearError();
      const file = entry.file;
      const status = row.querySelector('[data-pdf-status]');
      if (!/\.pdf$/i.test(file.name) && file.type !== 'application/pdf') {
        status.textContent = 'File non valido';
        return this.showError(`${file.name}: seleziona un file PDF valido.`);
      }
      const maxMb = Number(this.dataset.maxUploadMb || 20);
      if (maxMb > 0 && file.size > maxMb * 1024 * 1024) {
        status.textContent = 'File troppo grande';
        return this.showError(`${file.name} supera ${maxMb} MB. Riduci il peso del file prima di continuare.`);
      }

      entry.analyzing = true;
      this.progress.hidden = false;
      try {
        const pdfjs = this.getPdfEngine();
        const pdf = await pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()) }).promise;
        await this.renderFirstPagePreview(row, pdf);
        const groups = { bw: [], gray: [], color: [] };
        for (let number = 1; number <= pdf.numPages; number += 1) {
          this.setProgress(number - 1, pdf.numPages, `${file.name}: pagina ${number} di ${pdf.numPages}…`);
          const page = await pdf.getPage(number);
          const inspection = classifyOperators(pdfjs, await page.getOperatorList());
          let pageClass = inspection.kind;
          if (inspection.needsRaster && pageClass !== 'color') {
            const base = page.getViewport({ scale: 1 });
            const scale = Math.min(2.1, 1400 / Math.max(base.width, base.height));
            const viewport = page.getViewport({ scale: Math.max(1.35, scale) });
            const canvas = document.createElement('canvas');
            canvas.width = Math.ceil(viewport.width);
            canvas.height = Math.ceil(viewport.height);
            const context = canvas.getContext('2d', { alpha: false, willReadFrequently: true });
            context.fillStyle = '#fff';
            context.fillRect(0, 0, canvas.width, canvas.height);
            await page.render({ canvasContext: context, viewport }).promise;
            pageClass = strongestClass(pageClass, classifyPixels(context.getImageData(0, 0, canvas.width, canvas.height).data, canvas.width, canvas.height));
          }
          groups[pageClass].push(number);
          page.cleanup();
          await new Promise(requestAnimationFrame);
        }
        const analysis = { total: pdf.numPages, bw: groups.bw.length, gray: groups.gray.length, color: groups.color.length };
        await pdf.destroy();
        if (entry.file !== file) return;
        entry.analysis = analysis;
        const colorPages = analysis.color + analysis.gray;
        status.textContent = `${analysis.total} pagine · ${analysis.bw} BN · ${colorPages} colore/grigi`;
      } catch (error) {
        console.error(error);
        if (entry.file === file) {
          entry.analysis = null;
          status.textContent = 'Analisi non riuscita';
          this.showError(error?.name === 'PasswordException' ? `${file.name}: il PDF è protetto da password.` : `${file.name}: non è stato possibile analizzare il PDF.`);
        }
      } finally {
        entry.analyzing = false;
        this.progress.hidden = true;
        this.applyPaperRules();
        this.render();
      }
    }

    async renderFirstPagePreview(row, pdf) {
      const canvas = row.querySelector('[data-first-page-preview]');
      const box = row.querySelector('[data-frontespizio-check]');
      if (!canvas || !box || !pdf?.numPages) return;
      const page = await pdf.getPage(1);
      const base = page.getViewport({ scale: 1 });
      const scale = Math.min(1.2, 480 / Math.max(1, base.width));
      const viewport = page.getViewport({ scale: Math.max(0.72, scale) });
      canvas.width = Math.ceil(viewport.width);
      canvas.height = Math.ceil(viewport.height);
      const context = canvas.getContext('2d', { alpha: false });
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      await page.render({ canvasContext: context, viewport }).promise;
      page.cleanup();
      box.hidden = false;
    }

    frontespizioChoice(row) {
      return [...row.querySelectorAll('[data-frontespizio-choice]')].find((choice) => choice.checked)?.value || '';
    }

    validateFrontespizioChoices() {
      let invalidRow = null;
      for (const row of this.entries.keys()) {
        const invalid = !this.frontespizioChoice(row);
        const error = row.querySelector('[data-frontespizio-error]');
        if (error) error.hidden = !invalid;
        row.querySelector('[data-frontespizio-check]')?.classList.toggle('is-invalid', invalid);
        if (invalid && !invalidRow) invalidRow = row;
      }
      if (invalidRow) {
        this.showError('Controlla la prima pagina di ogni PDF e seleziona una delle due opzioni sul frontespizio interno.');
        invalidRow.querySelector('[data-frontespizio-check]')?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
        return false;
      }
      return true;
    }

    updateDuplexWarning() {
      const duplex = this.printModeInput?.value === 'Fronte e retro';
      if (this.duplexWarning) this.duplexWarning.hidden = !duplex;
      if (this.duplexConfirm) {
        this.duplexConfirm.required = duplex;
        if (!duplex) this.duplexConfirm.checked = false;
      }
    }

    validateDuplexConfirmation() {
      if (this.printModeInput?.value !== 'Fronte e retro' || this.duplexConfirm?.checked) return true;
      this.showError('Per la stampa fronte-retro conferma di aver controllato impaginazione, immagini, numeri di pagina e pagine bianche.');
      return false;
    }

    validateStep(step) {
      this.clearError();
      if (step === 1) {
        if (!this.allFilesReady()) { this.showError('Carica almeno un PDF e attendi la fine dell’analisi.'); return false; }
        if (![...this.entries.values()].every((entry) => entry.analysis?.total <= 660)) { this.showError('Un PDF supera 660 pagine e non può rientrare nel limite massimo di 330 fogli nemmeno in fronte-retro.'); return false; }
        return this.validateFrontespizioChoices();
      }
      if (step === 2) return this.validatePhysicalSheetLimit() && this.validateDuplexConfirmation();
      if (step === 3) {
        this.applyPaperRules();
        if (this.paperInput?.selectedOptions?.[0]?.disabled) { this.showError('Scegli una carta disponibile per questo numero di fogli.'); return false; }
        return true;
      }
      if (step === 4) {
        if (!this.primaryCover) { this.showError('Apri il configuratore partendo dalla copertina che vuoi acquistare.'); return false; }
        if (!this.wordInput?.files?.length && !this.savedWordUrl) { this.showError('Carica il frontespizio in Word per la copertina esterna.'); return false; }
        const phone = String(this.phoneInput?.value || '').trim();
        if (phone.replace(/\D/g, '').length < 6) { this.showError('Inserisci un numero di telefono valido.'); return false; }
        if (this.extraCover.cover && this.extraCover.mode === 'new') {
          if (!this.extraCover.analysis || this.extraCover.analyzing || (!this.extraCover.file && !this.extraCover.savedUrl)) { this.showError('Carica e attendi l’analisi del nuovo PDF per la seconda copertina.'); return false; }
          if (![...this.querySelectorAll('[data-extra-front-choice]')].some((radio)=>radio.checked)) { this.showError('Conferma il frontespizio interno anche per il nuovo PDF.'); return false; }
        }
        return true;
      }
      return true;
    }


    returnToCoverProduct() {
      const coverUrl = String(this.primaryCover?.url || '').trim();
      if (coverUrl) {
        window.location.href = coverUrl;
        return;
      }
      if (window.history.length > 1) {
        window.history.back();
        return;
      }
      window.location.href = '/collections/all';
    }

    nextStep() {
      if (!this.validateStep(this.currentStep)) return;
      if (this.currentStep < 5) this.goToStep(this.currentStep + 1);
    }

    goToStep(step) {
      const target = Math.max(1, Math.min(5, Number(step) || 1));
      this.currentStep = target;
      this.updateWizard();
      if (target === 5) this.render();
      this.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
    }

    updateWizard() {
      this.querySelectorAll('[data-wizard-panel]').forEach((panel) => {
        const active = Number(panel.dataset.wizardPanel) === this.currentStep;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      this.querySelectorAll('[data-step-jump]').forEach((button) => {
        const number = Number(button.dataset.stepJump);
        button.classList.toggle('is-active', number === this.currentStep);
        button.classList.toggle('is-complete', number < this.currentStep);
        button.disabled = number > this.currentStep;
      });
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.hidden = false;
      if (next) {
        const finalStep = this.currentStep === 5;
        next.hidden = finalStep;
        next.style.display = finalStep ? 'none' : '';
        next.textContent = 'Continua';
      }
    }

    getPdfEngine() {
      if (!window.pdfjsLib) throw new Error('Motore PDF non disponibile');
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = this.dataset.workerUrl;
      return window.pdfjsLib;
    }

    allFilesReady() {
      return this.entries.size > 0 && [...this.entries.values()].every((entry) => (entry.file || entry.savedUrl) && entry.analysis && !entry.analyzing);
    }

    getRowCopies(row) {
      return Math.max(1, Math.min(99, parseInt(row.querySelector('[data-pdf-copies]')?.value || '1', 10) || 1));
    }

    renderSummaryCopyControls() {
      const host = this.querySelector('[data-summary-copy-controls]');
      if (!host) return;
      const rows = [...this.entries.keys()];
      host.innerHTML = '';
      rows.forEach((row, index) => {
        const entry = this.entries.get(row);
        const wrap = document.createElement('div');
        wrap.className = 'copirema-wizard__summary-copy-row';
        const label = document.createElement('span');
        const fileName = entry?.file?.name || `PDF ${index + 1}`;
        label.textContent = rows.length > 1 ? fileName : 'Copie';
        const quantity = document.createElement('div');
        quantity.className = 'quantity copirema-wizard__summary-quantity';

        const minus = document.createElement('button');
        minus.className = 'quantity__button no-js-hidden';
        minus.type = 'button';
        minus.setAttribute('aria-label', 'Diminuisci numero copie');
        minus.textContent = '−';

        const input = document.createElement('input');
        input.className = 'quantity__input';
        input.type = 'number';
        input.min = '1';
        input.max = '99';
        input.inputMode = 'numeric';
        input.value = String(this.getRowCopies(row));
        input.setAttribute('aria-label', rows.length > 1 ? `Numero copie della tesi per ${fileName}` : 'Numero copie della tesi');

        const plus = document.createElement('button');
        plus.className = 'quantity__button no-js-hidden';
        plus.type = 'button';
        plus.setAttribute('aria-label', 'Aumenta numero copie');
        plus.textContent = '+';

        const setValue = (next) => {
          const value = Math.max(1, Math.min(99, parseInt(next || '1', 10) || 1));
          input.value = String(value);
          const source = row.querySelector('[data-pdf-copies]');
          if (source) {
            source.value = String(value);
            source.dispatchEvent(new Event('input', { bubbles: true }));
          } else {
            this.render();
          }
        };

        minus.addEventListener('click', () => setValue(Number(input.value || 1) - 1));
        plus.addEventListener('click', () => setValue(Number(input.value || 1) + 1));
        input.addEventListener('change', () => setValue(input.value));
        input.addEventListener('input', () => {
          const source = row.querySelector('[data-pdf-copies]');
          if (source) source.value = input.value;
        });

        quantity.append(minus, input, plus);
        wrap.append(label, quantity);
        host.appendChild(wrap);
      });
    }

    calculateTotals() {
      const totals = { pdfCount: this.entries.size, copies: 0, printedPages: 0, bwUnits: 0, colorUnits: 0 };
      const allBw = this.colorModeInput.value === 'all-bw';
      for (const [row, entry] of this.entries) {
        const copies = this.getRowCopies(row);
        totals.copies += copies;
        if (!entry.analysis) continue;
        const printed = entry.analysis.total * copies;
        totals.printedPages += printed;
        if (allBw) totals.bwUnits += printed;
        else { totals.bwUnits += entry.analysis.bw * copies; totals.colorUnits += (entry.analysis.color + entry.analysis.gray) * copies; }
      }
      if (this.extraCover.cover) {
        const copies = Math.max(1, Number(this.extraCover.copies || 1));
        if (this.extraCover.mode === 'new' && this.extraCover.analysis) {
          const a = this.extraCover.analysis;
          const printed = a.total * copies;
          totals.printedPages += printed;
          totals.pdfCount += 1;
          if (allBw) totals.bwUnits += printed;
          else { totals.bwUnits += a.bw * copies; totals.colorUnits += (a.color + a.gray) * copies; }
        } else if (this.extraCover.mode === 'same') {
          for (const [, entry] of this.entries) {
            if (!entry.analysis) continue;
            const a = entry.analysis;
            const printed = a.total * copies;
            totals.printedPages += printed;
            if (allBw) totals.bwUnits += printed;
            else { totals.bwUnits += a.bw * copies; totals.colorUnits += (a.color + a.gray) * copies; }
          }
        }
        totals.copies += copies;
      }
      return totals;
    }

    sheetsForPages(pages) {
      return sheetCount(pages, this.printModeInput?.value === 'Fronte e retro');
    }

    validatePhysicalSheetLimit() {
      const analyses = [...this.entries.values()].map((entry) => entry.analysis).filter(Boolean);
      if (this.extraCover.cover && this.extraCover.mode === 'new' && this.extraCover.analysis) analyses.push(this.extraCover.analysis);
      for (const analysis of analyses) {
        const sheets = this.sheetsForPages(analysis.total);
        if (sheets > 330) {
          const duplex = this.printModeInput.value === 'Fronte e retro';
          this.showError(`Con la modalità ${duplex ? 'fronte/retro' : 'solo fronte'}, uno dei PDF richiede ${sheets} fogli. Il limite massimo è 330 fogli. ${duplex ? 'Riduci il numero di pagine del PDF.' : 'Prova a selezionare la stampa fronte/retro.'}`);
          return false;
        }
      }
      if (this.errorBox?.textContent?.includes('Il limite massimo è 330 fogli')) this.clearError();
      return true;
    }

    applyPaperRules() {
      const analyses = [...this.entries.values()].map((entry) => entry.analysis).filter(Boolean);
      if (this.extraCover.cover && this.extraCover.mode === 'new' && this.extraCover.analysis) analyses.push(this.extraCover.analysis);
      const options = [...this.paperInput.options];
      if (!analyses.length) {
        options.forEach((option) => { option.disabled = false; if (option.dataset.baseLabel) option.textContent = option.dataset.baseLabel; });
        this.paperNotice.hidden = true;
        return;
      }
      const maxSheets = Math.max(...analyses.map((analysis) => this.sheetsForPages(analysis.total)));
      const policy = paperPolicy(maxSheets);
      options.forEach((option) => {
        if (!option.dataset.baseLabel) option.dataset.baseLabel = option.textContent;
        const standard80 = option.value === '80';
        const recycled80 = option.value === '80-RICICLATA';
        const is120 = option.value === '120-OPACO' || option.value === '120-LUCIDO';
        option.disabled = policy.onlyStandard80 ? !standard80 : (policy.no120 && is120) || (policy.noRecycled && recycled80);
        option.textContent = `${option.dataset.baseLabel}${option.disabled ? ' — non disponibile per questo numero di fogli' : ''}`;
      });
      if (this.paperInput.selectedOptions[0]?.disabled) {
        this.paperInput.value = policy.onlyStandard80 || this.paperInput.value === '80-RICICLATA' ? '80' : '100-OPACO';
      }
      const selected80 = this.paperInput.value === '80' || this.paperInput.value === '80-RICICLATA';
      if (policy.onlyStandard80) this.setPaperNotice('Per questo numero di fogli è disponibile soltanto la carta 80 grammi standard.');
      else if (policy.noRecycled) this.setPaperNotice('La carta 120 grammi non è disponibile oltre 80 fogli e la carta 80 grammi riciclata è disponibile fino a 130 fogli.');
      else if (policy.no120) this.setPaperNotice('Oltre 80 fogli la carta 120 grammi non è disponibile; puoi scegliere una carta da 80 o 100 grammi.');
      else if (maxSheets < 50 && selected80) this.setPaperNotice('Per una tesi sotto i 50 fogli consigliamo la carta 120 grammi, più consistente. Il consiglio è facoltativo.');
      else { this.paperNotice.hidden = true; this.paperNotice.textContent = ''; }
    }

    setPaperNotice(message) { this.paperNotice.textContent = message; this.paperNotice.hidden = false; }

    updateColorHelp() {
      this.querySelector('[data-color-help]').textContent = this.colorModeInput.value === 'all-bw'
        ? 'Tutte le pagine di tutti i PDF saranno conteggiate con la tariffa bianco e nero.'
        : 'Solo le pagine contenenti colori o elementi in scala di grigi saranno tariffate a colori. Le restanti saranno tariffate in bianco e nero.';
    }

    render() {
      this.renumberRows();
      this.applyPaperRules();
      this.updatePrimaryCoverPricing();
      this.updateStepOneCosts();
      if (!this.allFilesReady()) return;
      const totals = this.calculateTotals();
      const cover = this.selectedCover();
      const paper = PAPERS[this.paperInput.value];
      if (!paper) return;
      const printCents = totals.bwUnits * paper.bw + totals.colorUnits * paper.color;
      let coverGrossCents = 0, coverDiscountCents = 0;
      const primaryCopies = [...this.entries.keys()].reduce((sum,row)=>sum+this.getRowCopies(row),0);
      const coverLines = cover ? [{cover, copies: primaryCopies}] : [];
      if (this.extraCover.cover) coverLines.push({cover:this.extraCover.cover,copies:Math.max(1,Number(this.extraCover.copies||1))});
      const groupCounts = new Map();
      for (const line of coverLines) { coverGrossCents += line.cover.price * line.copies; const group=discountGroupFor(line.cover.title); if(group) groupCounts.set(group.key,{group,count:(groupCounts.get(group.key)?.count||0)+line.copies}); }
      for (const {group,count} of groupCounts.values()) coverDiscountCents = Math.max(coverDiscountCents, discountForQuantity(group.rates,count));
      const coverNetCents = Math.max(0, coverGrossCents - coverDiscountCents);
      const shippingCents = totals.copies >= 2 ? 0 : 500;
      this.querySelector('[data-total-pages]').textContent = totals.printedPages;
      this.querySelector('[data-bw-count]').textContent = totals.bwUnits;
      this.querySelector('[data-color-count]').textContent = totals.colorUnits;
      this.querySelector('[data-pdf-count]').textContent = `${totals.pdfCount} PDF`;
      this.querySelector('[data-copy-count]').textContent = `${totals.copies} ${totals.copies === 1 ? 'copia' : 'copie'}`;
      this.querySelector('[data-summary-paper]').textContent = `Carta: ${paper.label}`;
      if (this.currentStep === 5) this.renderSummaryCopyControls();
      const coverTotalNode = this.querySelector('[data-cover-total]');
      const coverGrossNode = this.querySelector('[data-cover-gross]');
      const coverDiscountNote = this.querySelector('[data-cover-discount-note]');
      const coverDiscountNode = this.querySelector('[data-cover-discount]');
      if (coverTotalNode) coverTotalNode.textContent = cover ? formatMoney(coverNetCents) : '—';
      if (coverGrossNode) { coverGrossNode.hidden = !cover || coverDiscountCents <= 0; coverGrossNode.textContent = formatMoney(coverGrossCents); }
      if (coverDiscountNote && coverDiscountNode) { coverDiscountNote.hidden = !cover || coverDiscountCents <= 0; coverDiscountNode.textContent = `−${formatMoney(coverDiscountCents)}`; }
      this.querySelector('[data-print-total]').textContent = formatMoney(printCents);
      this.renderPrintBreakdown(paper);
      this.querySelector('[data-shipping]').textContent = shippingCents ? formatMoney(shippingCents) : 'GRATUITA';
      this.querySelector('[data-shipping-promo]').textContent = shippingCents ? 'Acquista almeno 2 copie e hai la spedizione gratuita.' : 'Promo 2 o più copie applicata.';
      const finalTotalCents = coverNetCents + printCents + shippingCents;
      this.querySelector('[data-total]').textContent = cover ? formatMoney(finalTotalCents) : '—';
      this.renderCopyBenefits({ totals, cover, printCents, coverDiscountCents, finalTotalCents });
    }

    renderPrintBreakdown(paper) {
      const host = this.querySelector('[data-print-breakdown]');
      if (!host || !paper) return;
      host.innerHTML = '';
      const allBw = this.colorModeInput.value === 'all-bw';
      const groups = [];

      [...this.entries.entries()].forEach(([row, entry], index) => {
        if (!entry.analysis) return;
        groups.push({
          title: entry.savedName || entry.file?.name || `PDF ${index + 1}`,
          analysis: entry.analysis,
          copies: this.getRowCopies(row)
        });
      });

      if (this.extraCover.cover) {
        const copies = Math.max(1, Number(this.extraCover.copies || 1));
        if (this.extraCover.mode === 'new' && this.extraCover.analysis) {
          groups.push({
            title: `${this.extraCover.file?.name || 'PDF seconda copertina'} · seconda copertina`,
            analysis: this.extraCover.analysis,
            copies
          });
        } else if (this.extraCover.mode === 'same') {
          [...this.entries.entries()].forEach(([row, entry], index) => {
            if (!entry.analysis) return;
            groups.push({
              title: `${entry.savedName || entry.file?.name || `PDF ${index + 1}`} · seconda copertina`,
              analysis: entry.analysis,
              copies
            });
          });
        }
      }

      if (!groups.length) {
        host.hidden = true;
        return;
      }
      host.hidden = false;

      const heading = document.createElement('strong');
      heading.className = 'copirema-wizard__print-breakdown-title';
      heading.textContent = 'Calcolo del costo di stampa';
      host.appendChild(heading);

      const formatRate = (cents) => formatMoney(cents);
      const formula = (pages, rate, copies) => {
        const total = pages * rate * copies;
        const copyPart = copies > 1 ? ` × ${copies} copie` : '';
        return `${pages} ${pages === 1 ? 'pagina' : 'pagine'} × ${formatRate(rate)}${copyPart} = ${formatMoney(total)}`;
      };

      groups.forEach((group) => {
        const block = document.createElement('div');
        block.className = 'copirema-wizard__print-breakdown-file';
        const name = document.createElement('span');
        name.className = 'copirema-wizard__print-breakdown-name';
        name.textContent = group.title;
        block.appendChild(name);

        if (allBw) {
          const line = document.createElement('div');
          line.innerHTML = `<span>Bianco e nero</span><strong>${formula(group.analysis.total, paper.bw, group.copies)}</strong>`;
          block.appendChild(line);
        } else {
          const bwPages = Number(group.analysis.bw || 0);
          const colorPages = Number(group.analysis.color || 0) + Number(group.analysis.gray || 0);
          if (bwPages > 0) {
            const line = document.createElement('div');
            line.innerHTML = `<span>Bianco e nero</span><strong>${formula(bwPages, paper.bw, group.copies)}</strong>`;
            block.appendChild(line);
          }
          if (colorPages > 0) {
            const line = document.createElement('div');
            line.innerHTML = `<span>Colori / scala di grigi</span><strong>${formula(colorPages, paper.color, group.copies)}</strong>`;
            block.appendChild(line);
          }
        }
        host.appendChild(block);
      });
    }

    renderCopyBenefits({ totals, cover, printCents, coverDiscountCents, finalTotalCents }) {
      const box = this.querySelector('[data-copy-benefits]');
      if (!box) return;
      box.hidden = !cover || !this.allFilesReady();
      if (box.hidden) return;

      const title = box.querySelector('[data-benefit-title]');
      const text = box.querySelector('[data-benefit-text]');
      const shipping = box.querySelector('[data-benefit-shipping]');
      const discountRow = box.querySelector('[data-benefit-discount-row]');
      const discount = box.querySelector('[data-benefit-discount]');
      const totalLabel = box.querySelector('[data-benefit-total-label]');
      const total = box.querySelector('[data-benefit-total]');
      const saving = box.querySelector('[data-benefit-saving]');
      const freeShipping = totals.copies >= 2;

      if (!freeShipping && totals.copies === 1 && this.entries.size === 1 && !this.extraCover.cover) {
        const group = discountGroupFor(cover.title);
        const projectedDiscount = group ? discountForQuantity(group.rates, 2) : 0;
        const projectedCoverGross = Number(cover.price || 0) * 2;
        const projectedCoverNet = Math.max(0, projectedCoverGross - projectedDiscount);
        const projectedPrint = printCents * 2;
        const projectedTotal = projectedCoverNet + projectedPrint;
        const projectedSaving = projectedDiscount + 500;

        title.textContent = 'Aggiungi una seconda copia e sblocca i vantaggi';
        text.textContent = projectedDiscount > 0
          ? 'Ottieni la spedizione gratuita e lo sconto sulla copertina.'
          : 'Ottieni la spedizione gratuita.';
        shipping.textContent = 'GRATUITA';
        discountRow.hidden = projectedDiscount <= 0;
        discount.textContent = projectedDiscount > 0 ? `−${formatMoney(projectedDiscount)}` : '—';
        totalLabel.textContent = 'Totale con 2 copie (stampe incluse)';
        total.textContent = formatMoney(projectedTotal);
        saving.textContent = formatMoney(projectedSaving);
      } else {
        const promoSaving = coverDiscountCents + (freeShipping ? 500 : 0);
        title.textContent = freeShipping ? 'Hai sbloccato i vantaggi!' : 'Vantaggi sulle copie';
        text.textContent = freeShipping
          ? (coverDiscountCents > 0 ? 'Spedizione gratuita e sconto copertina applicati.' : 'Spedizione gratuita applicata.')
          : 'Aumenta il numero di copie per sbloccare le promozioni disponibili.';
        shipping.textContent = freeShipping ? 'GRATUITA' : '€5,00';
        discountRow.hidden = coverDiscountCents <= 0;
        discount.textContent = coverDiscountCents > 0 ? `−${formatMoney(coverDiscountCents)}` : '—';
        totalLabel.textContent = 'Totale complessivo (stampe incluse)';
        total.textContent = formatMoney(finalTotalCents);
        saving.textContent = formatMoney(promoSaving);
      }

      if (this.currentStep === 5) {
        if (freeShipping && !this.lastFreeShippingState) {
          box.classList.remove('is-unlocked');
          void box.offsetWidth;
          box.classList.add('is-unlocked');
          window.setTimeout(() => box.classList.remove('is-unlocked'), 950);
        }
        this.lastFreeShippingState = freeShipping;
      }
    }

    fileSummary() {
      return [...this.entries].map(([row, entry], index) => {
        const sheets = entry.analysis ? `, ${this.sheetsForPages(entry.analysis.total)} fogli` : '';
        return `${index + 1}. ${entry.file?.name || entry.savedName || 'PDF mancante'} (${this.getRowCopies(row)} ${this.getRowCopies(row) === 1 ? 'copia' : 'copie'}${sheets})`;
      }).join(' · ');
    }

    frontespizioSummary() {
      const parts = [...this.entries.keys()].map((row, index) => {
        const choice = this.frontespizioChoice(row);
        return `PDF ${index + 1}: ${choice === 'present' ? 'presente e confermato' : choice === 'none' ? 'non richiesto' : 'non confermato'}`;
      });
      if (this.extraCover.cover && this.extraCover.mode === 'new') {
        const choice = [...this.querySelectorAll('[data-extra-front-choice]')].find((radio) => radio.checked)?.value || '';
        parts.push(`PDF seconda copertina: ${choice === 'present' ? 'presente e confermato' : choice === 'none' ? 'non richiesto' : 'non confermato'}`);
      }
      return parts.join(' · ');
    }

    printItem(sku, quantity, jobId, totals) {
      const variant = this.printVariants.get(sku);
      if (!variant?.id) throw new Error(`Tariffa stampa non configurata: ${sku}`);
      return {
        id: variant.id,
        quantity,
        properties: {
          '_Riferimento lavorazione': jobId,
          'Carta': PAPERS[this.paperInput.value]?.label || this.paperInput.value,
          'Scelta colore': this.colorModeInput.options[this.colorModeInput.selectedIndex]?.text || '',
          'PDF e copie': this.fileSummary().slice(0, 240),
          'Copie complessive': totals.copies
        }
      };
    }

    appendPrimaryFiles(formData) {
      let index = 0;
      for (const [row, entry] of this.entries) {
        index += 1;
        if (entry.file) formData.append(`properties[PDF tesi ${index}]`, entry.file, entry.file.name);
        else if (entry.savedUrl) formData.append(`properties[PDF tesi ${index}]`, entry.savedUrl);
      }
      const word = this.wordInput?.files?.[0];
      if (word) formData.append('properties[Frontespizio Word]', word, word.name);
      else if (this.savedWordUrl) formData.append('properties[Frontespizio Word]', this.savedWordUrl);
    }

    buildCoverFormData(cover, copies, jobId, includeWord = false, useExtraNewPdf = false) {
      const formData = new FormData();
      const variantId = Number(cover?.variantId || 0);
      if (!variantId) throw new Error(`Variante della copertina ${cover?.title || ''} non disponibile.`);
      formData.append('id', String(variantId));
      formData.append('quantity', String(Math.max(1, Number(copies || 1))));
      formData.append('properties[_Riferimento lavorazione]', jobId);
      formData.append('properties[Modalità di stampa]', this.printModeInput.value);
      formData.append('properties[Carta]', PAPERS[this.paperInput.value]?.label || this.paperInput.value);
      formData.append('properties[Scelta colore]', this.colorModeInput.options[this.colorModeInput.selectedIndex]?.text || '');
      formData.append('properties[PDF e copie]', this.fileSummary().slice(0, 240));
      formData.append('properties[Frontespizio interno]', this.frontespizioSummary().slice(0, 240));
      const phone = String(this.phoneInput?.value || '').trim();
      if (phone) formData.append('properties[Telefono ordine]', phone);
      if (includeWord) this.appendPrimaryFiles(formData);
      else if (useExtraNewPdf && this.extraCover.file) formData.append('properties[PDF tesi]', this.extraCover.file, this.extraCover.file.name);
      else if (useExtraNewPdf && this.extraCover.savedUrl) formData.append('properties[PDF tesi]', this.extraCover.savedUrl);
      else {
        let index = 0;
        for (const [, entry] of this.entries) {
          index += 1;
          if (entry.file) formData.append(`properties[PDF tesi ${index}]`, entry.file, entry.file.name);
        else if (entry.savedUrl) formData.append(`properties[PDF tesi ${index}]`, entry.savedUrl);
        }
      }
      return formData;
    }

    async addFormDataToCart(formData) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(window.routes?.cart_add_url || `${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Impossibile aggiungere la copertina.');
      return result;
    }

    async rollbackJob(jobId) {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) return;
        const cart = await cartResponse.json();
        const created = cart.items.filter((item) => item.properties?.['_Riferimento lavorazione'] === jobId);
        for (const item of created) {
          await fetch(window.routes?.cart_change_url || `${root}cart/change.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        }
      } catch (error) {
        console.error('Rollback configuratore non riuscito', error);
      }
    }

    async submitOrder() {
      if (this.submitting) return;
      this.clearError();
      for (let step = 1; step <= 4; step += 1) {
        if (!this.validateStep(step)) {
          this.goToStep(step);
          return;
        }
      }
      if (!this.validatePhysicalSheetLimit()) return;
      this.applyPaperRules();
      if (this.paperInput?.selectedOptions?.[0]?.disabled) return this.showError('Scegli una carta disponibile per questo numero di fogli.');
      if (!this.primaryCover?.variantId) return this.showError('La variante della copertina scelta non è disponibile. Torna alla copertina e riprova.');
      const totals = this.calculateTotals();
      const paper = PAPERS[this.paperInput.value];
      if (!paper) return this.showError('Carta non configurata.');
      const requiredSkus = [];
      if (totals.colorUnits) requiredSkus.push(`COP-${this.paperInput.value}-COLORE`);
      if (totals.bwUnits) requiredSkus.push(`COP-${this.paperInput.value}-BN`);
      const missing = requiredSkus.find((sku) => !this.printVariants.get(sku)?.id);
      if (missing) return this.showError('Il prodotto tecnico della stampa non è configurato nel configuratore.');

      this.submitting = true;
      const button = this.querySelector('[data-submit-order]');
      button?.classList.add('loading');
      button?.setAttribute('aria-disabled', 'true');
      if (button) button.disabled = true;
      const oldJobId = this.persistedJobId;
      const jobId = `TESI-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;
      try {
        const printItems = [];
        if (totals.colorUnits) printItems.push(this.printItem(`COP-${this.paperInput.value}-COLORE`, totals.colorUnits, jobId, totals));
        if (totals.bwUnits) printItems.push(this.printItem(`COP-${this.paperInput.value}-BN`, totals.bwUnits, jobId, totals));
        if (printItems.length) {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(window.routes?.cart_add_url || `${root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: printItems })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Impossibile aggiungere i costi di stampa.');
        }

        const primaryCopies = [...this.entries.keys()].reduce((sum, row) => sum + this.getRowCopies(row), 0);
        const primaryResult = await this.addFormDataToCart(this.buildCoverFormData(this.primaryCover, primaryCopies, jobId, true, false));
        this.captureUploadedProperties(primaryResult);

        if (this.extraCover.cover) {
          const extraCopies = Math.max(1, Number(this.extraCover.copies || 1));
          const extraResult = await this.addFormDataToCart(this.buildCoverFormData(
            this.extraCover.cover,
            extraCopies,
            jobId,
            false,
            this.extraCover.mode === 'new'
          ));
          if (this.extraCover.mode === 'new') {
            const value = extraResult?.properties?.['PDF tesi'];
            if (value) this.extraCover.savedUrl = String(value);
            if (this.extraCover.file?.name) this.extraCover.savedName = this.extraCover.file.name;
          }
        }

        if (oldJobId && oldJobId !== jobId) await this.rollbackJob(oldJobId);
        this.persistedJobId = jobId;
        this.savePersistedState(jobId);
        const root = window.Shopify?.routes?.root || '/';
        window.location.assign(window.routes?.cart_url || `${root}cart`);
      } catch (error) {
        console.error(error);
        await this.rollbackJob(jobId);
        this.showError(error.message || 'Si è verificato un errore. Riprova.');
        this.submitting = false;
        button?.classList.remove('loading');
        button?.removeAttribute('aria-disabled');
        if (button) button.disabled = false;
      }
    }

    setProgress(done, total, label) {
      const percent = total ? Math.round(done / total * 100) : 0;
      this.querySelector('[data-progress-label]').textContent = label;
      this.querySelector('[data-progress-percent]').textContent = `${percent}%`;
      this.querySelector('[data-progress-bar]').style.width = `${percent}%`;
    }
    showError(message) { this.errorBox.textContent = message; this.errorBox.hidden = false; }
    clearError() { this.errorBox.hidden = true; this.errorBox.textContent = ''; }
  }

  function normalizeProductName(value) {
    return String(value || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }
  function discountGroupFor(title) {
    const normalized = normalizeProductName(title);
    return COVER_DISCOUNT_GROUPS.find((group) => group.normalized.has(normalized)) || null;
  }
  function discountForQuantity(rates, quantity) {
    if (quantity >= 5) return rates[5] || 0;
    if (quantity >= 4) return rates[4] || 0;
    if (quantity >= 3) return rates[3] || 0;
    if (quantity >= 2) return rates[2] || 0;
    return 0;
  }

  function classifyOperators(pdfjs, operatorList) {
    const O = pdfjs.OPS;
    let state = { fill: 'bw', stroke: 'bw', textMode: 0 }, kind = 'bw', needsRaster = false;
    const stack = [];
    const use = (paint) => { if (paint === 'complex') needsRaster = true; else kind = strongestClass(kind, paint); };
    const useText = () => {
      if ([0, 2, 4, 6].includes(state.textMode)) use(state.fill);
      if ([1, 2, 5, 6].includes(state.textMode)) use(state.stroke);
    };
    const visibleText = (args) => {
      const chunks = args?.[0];
      return !Array.isArray(chunks) || chunks.some((item) => item && typeof item === 'object' && !item.isSpace && /[^\s\u0000-\u001f]/u.test(item.unicode || ''));
    };
    const imageOps = new Set([O.paintImageXObject, O.paintInlineImageXObject, O.paintImageXObjectRepeat, O.paintInlineImageXObjectGroup]);
    for (let i = 0; i < operatorList.fnArray.length; i += 1) {
      const fn = operatorList.fnArray[i], args = operatorList.argsArray[i];
      if (fn === O.save) stack.push({ ...state });
      else if (fn === O.restore && stack.length) state = stack.pop();
      else if (fn === O.setFillRGBColor) state.fill = colorClass(args);
      else if (fn === O.setStrokeRGBColor) state.stroke = colorClass(args);
      else if (fn === O.setFillColorN) state.fill = 'complex';
      else if (fn === O.setStrokeColorN) state.stroke = 'complex';
      else if (fn === O.setTextRenderingMode) state.textMode = args?.[0] ?? 0;
      else if (imageOps.has(fn) || fn === O.shadingFill) needsRaster = true;
      else if (fn === O.paintImageMaskXObject || fn === O.paintSolidColorImageMask) use(state.fill);
      else if (fn === O.stroke || fn === O.closeStroke) use(state.stroke);
      else if (fn === O.fill || fn === O.eoFill) use(state.fill);
      else if ([O.fillStroke, O.eoFillStroke, O.closeFillStroke, O.closeEOFillStroke].includes(fn)) { use(state.fill); use(state.stroke); }
      else if ([O.showText, O.showSpacedText, O.nextLineShowText, O.nextLineSetSpacingShowText].includes(fn) && visibleText(args)) useText();
    }
    return { kind, needsRaster };
  }
  function colorClass(v) {
    if (!v || v.length < 3) return 'complex';
    const hi = Math.max(+v[0], +v[1], +v[2]), lo = Math.min(+v[0], +v[1], +v[2]);
    if (lo >= 250) return 'bw';
    if (hi - lo >= 8) return 'color';
    return hi <= 5 ? 'bw' : 'gray';
  }
  function strongestClass(a, b) { return ({ bw: 0, gray: 1, color: 2 })[b] > ({ bw: 0, gray: 1, color: 2 })[a] ? b : a; }
  function classifyPixels(data, width, height) {
    let colored = 0, gray = 0, marked = 0;
    const dark = new Uint8Array(width * height);
    for (let i = 0, p = 0; i < data.length; i += 4, p += 1) {
      const r = data[i], g = data[i + 1], b = data[i + 2], hi = Math.max(r, g, b), lo = Math.min(r, g, b);
      if (lo >= 251) continue;
      marked += 1;
      const light = (r * 299 + g * 587 + b * 114) / 1000;
      if (hi - lo >= 14 && light < 254) colored += 1;
      if (light <= 38) dark[p] = 1;
    }
    if (colored > Math.max(10, Math.floor(marked * 0.00015))) return 'color';
    for (let i = 0, p = 0; i < data.length; i += 4, p += 1) {
      const r = data[i], g = data[i + 1], b = data[i + 2];
      if (Math.max(r, g, b) - Math.min(r, g, b) >= 14) continue;
      const light = (r * 299 + g * 587 + b * 114) / 1000;
      if (light <= 42 || light >= 250) continue;
      const x = p % width, y = Math.floor(p / width);
      let nearBlack = false;
      for (let dy = -2; dy <= 2 && !nearBlack; dy += 1) {
        const yy = y + dy;
        if (yy < 0 || yy >= height) continue;
        for (let dx = -2; dx <= 2; dx += 1) {
          const xx = x + dx;
          if (xx >= 0 && xx < width && dark[yy * width + xx]) { nearBlack = true; break; }
        }
      }
      if (!nearBlack) gray += 1;
    }
    return gray > Math.max(12, Math.floor(marked * 0.00025)) ? 'gray' : 'bw';
  }
  function formatMoney(cents) { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(Number(cents || 0) / 100); }
  function sheetCount(pages, duplex) { return duplex ? Math.ceil(pages / 2) : pages; }
  function paperPolicy(sheets) { return { onlyStandard80: sheets > 260, noRecycled: sheets > 130, no120: sheets > 80, recommend120: sheets < 50 }; }

  Object.defineProperty(window, '__COPIREMA_QUOTE_TEST__', { value: { sheetCount, paperPolicy, PAPERS, discountGroupFor, discountForQuantity }, configurable: true });
  customElements.define('copirema-thesis-wizard', CopiremaQuickQuote);
})();
